import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { useParams, useSearchParams, useHistory } from "react-router-dom";

import FullScreenLoader from "../components/fullScreenLoader";
import Dashboard from "./dashboard";
import api from "../services/api";

//The big rabbit video
// const STREAM_URL = "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8";

export default function FullScreenHlsVideo() {
  const { token } = useParams();

  const [cameraId, setCameraId] = useState();
  const [streamURL, setStreamURL] = useState();
  const [waterMark, setWaterMark] = useState();
  const [expiration, setExpiration] = useState();

  const videoRef = useRef(null);
  const timeoutRef = useRef();

  const history = useHistory();

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (Hls.isSupported()) {
      const hls = new Hls();

      hls.loadSource(streamURL);
      hls.attachMedia(video);

      return () => {
        hls.destroy();
      };
    } else {
      // Safari (native HLS)
      video.src = streamURL;
    }
  }, [streamURL]);

  useEffect(() => {
    if (!token) return;

    requestCameraId();
  }, [token]);

  useEffect(() => {
    if (!cameraId) return;

    requestCameraToken();
  }, [cameraId]);

  useEffect(() => {
    if (!expiration) return;

    // Clear any previous timeout
    clearTimeout(timeoutRef.current);

    const now = Date.now();

    // Refresh 1 minute BEFORE expiration
    const refreshAt = expiration - 60 * 1000;

    const delay = Math.max(refreshAt - now, 0);

    timeoutRef.current = setTimeout(() => {
      requestCameraToken();
    }, delay);

    return () => clearTimeout(timeoutRef.current);
  }, [expiration]);

  const requestCameraId = async () => {
    //Token decode failure. Must try resolve url_alias
    try {
      const response = await api.get(`/location/?url_alias=${token}`);

      if (
        !response ||
        response?.length === 0 ||
        response?.error ||
        !response?.data?.[0]?.id
      ) {
        history.push("/notfound");

        return;
      }

      const location = response.data[0];

      const cameraId = location?.cameras[0]?.id;

      if (!cameraId) return; //Ethernal loading....

      document.title = location?.campaign?.title
        ? `Windradar - ${location?.campaign?.title}`
        : `Dashboard`;

      console.log("camera >>>>>>", cameraId);
      setCameraId(cameraId);
    } catch (e) {
      console.error("erro =>", e);
    }
  };

  const requestCameraToken = async () => {
    try {
      const url = `/location/camera/token/${cameraId}`;

      console.log(url);

      const { data } = await api.get(url);

      if (!data?.stream_url) {
        throw new Error("stream_url not found");
      }
      console.log(data.stream_url);

      setStreamURL(data.stream_url);
      setExpiration(data.expiration_millis);
      setWaterMark(data.camera_watermark.url);
    } catch (e) {
      console.log("requestCameraToken failed:", e);
    }
  };

  const enterFullScreen = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen(); // Safari
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen(); // IE
    }
  };

  if (!streamURL) {
    return <FullScreenLoader label="Carregando dados..." />;
  }

  return (
    <div style={styles.container}>
      <div style={styles.dashboard}>
        <Dashboard />
      </div>
      <video
        ref={videoRef}
        controls
        autoPlay
        playsInline
        style={styles.video}
      />
      <div style={styles.imageContainer}>
        <img
          src={waterMark}
          alt="Logo"
          style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: 12 }}
        />
      </div>
    </div>
  );
}

/* ─────────────────────────── */
/* Styles                       */
/* ─────────────────────────── */

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    background: "black",
    position: "relative",
  },
  dashboard: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "20vw",
    height: "100vh",

    zIndex: 10,

    /* CRITICAL */
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  button: {
    position: "absolute",
    bottom: 20,
    left: 20,
    padding: "10px 16px",
    cursor: "pointer",
  },
  imageContainer: {
    position: "absolute",
    top: 30,
    left: 0,

    width: "12vw",
    height: "12vh",

    opacity: 0.5,
    // backgroundColor: "rgba(0, 0, 0, 0.7)", // 70% opacity
    borderRadius: 16, // rounded borders

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    zIndex: 10,
  },
};
